import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';
import { SentryService } from '@mnz-core/services/sentry.service';
import { getAppBaseUrl } from '@mnz-shared/shared.constants';
import * as appActions from '@mnz-store/actions/app.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, tap } from 'rxjs/operators';

@Injectable()
export class AppEffects {
  constructor(
    @Inject(APP_CONFIG) private readonly _config: IAppConfiguration,
    private readonly _actions$: Actions,
    private readonly _sentry: SentryService
  ) {}

  /**
   * Dispatch the action which is in the payload of a message
   */
  dispatchOnError$ = createEffect(() =>
    this._actions$.pipe(
      ofType(appActions.addMessage),
      filter(({ action }) => action != null),
      map(({ action }) => action)
    )
  );

  /**
   * Log errors to sentry
   *
   * @description redirect if http status 503 or 429
   */
  handleError$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(appActions.addMessage),
        map(({ message }) => message),
        filter(({ error }) => error != null),
        tap(({ body, error }) => this._sentry.logError(error, { body })),
        filter(({ error }) => error instanceof HttpErrorResponse),
        tap(({ error }) => {
          const e = error as HttpErrorResponse;

          // out of service
          if (environment.production && e.status === 503) {
            const { redirect_url } = this._config;
            location.assign(redirect_url);
          }

          // rate limited, user performed to much logins within a specific time window
          if (environment.production && e.status === 429) {
            const { language } = this._config.relay42_config;
            const path = `${getAppBaseUrl(this._config.contextPath)}/signinold?forceold=true&taal=${language}`;

            setTimeout(() => location.assign(path), 2500);
          }
        })
      ),
    { dispatch: false }
  );
}
